import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { ButtonModule } from '../button/button.module';
import { SearchModule } from '../search/search.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { LoaderModule } from '../loader/loader.module';
import { ReceiversAdvancedSearchComponent } from './receivers-advanced-search/receivers-advanced-search.component';
import { ReceiversService } from './receivers.service';
import { ReceiversSearchService } from './search/receivers-search.service';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    SearchModule,
    SpinnerModule,
    LoaderModule,
  ],
  declarations: [
    ReceiversAdvancedSearchComponent,
  ],
  exports: [
    ReceiversAdvancedSearchComponent,
  ],
  providers: [ReceiversService, ReceiversSearchService]
})
export class ReceiversSharedModule {}
